// Neutral, policy-safe Google Play review invitations for all seven locales.
export const PLAY_REVIEW_OVERLAY = {
  "en": {
    "playReview": {
      "title": "Your opinion matters!",
      "body": "You've logged 5 or more matches. An honest review on Google Play helps other players discover Tennis Log and helps us improve.",
      "later": "Later",
      "action": "Review on Google Play",
      "diagTitle": "Play review invitation",
      "diag_eligible": "Eligible for an invitation",
      "diag_not_android_app": "Only inside an installed Android app",
      "diag_under_five": "Available after 5 matches",
      "diag_cooldown": "Waiting for the 30-day cooldown",
      "diag_opted_out": "No more invitations (previous choice)",
      "diag_storage_unavailable": "Cannot save preferences",
      "diag_signed_out": "Sign in required",
      "diag_loading": "Checking matches…"
    }
  },
  "el": {
    "playReview": {
      "title": "Η γνώμη σου μετράει!",
      "body": "Έχεις καταγράψει τουλάχιστον 5 αγώνες. Μια ειλικρινής αξιολόγηση στο Google Play βοηθά περισσότερους τενίστες να γνωρίσουν το Tennis Log και εμάς να το βελτιώνουμε.",
      "later": "Αργότερα",
      "action": "Αξιολόγηση στο Google Play",
      "diagTitle": "Πρόσκληση αξιολόγησης Play",
      "diag_eligible": "Έτοιμη για εμφάνιση",
      "diag_not_android_app": "Μόνο σε εγκατεστημένη Android εφαρμογή",
      "diag_under_five": "Διαθέσιμη μετά από 5 αγώνες",
      "diag_cooldown": "Αναμονή 30 ημερών",
      "diag_opted_out": "Δεν θα εμφανιστεί ξανά (προηγούμενη επιλογή)",
      "diag_storage_unavailable": "Μη διαθέσιμη αποθήκευση προτιμήσεων",
      "diag_signed_out": "Απαιτείται σύνδεση",
      "diag_loading": "Έλεγχος αγώνων…"
    }
  },
  "es": {
    "playReview": {
      "title": "¡Tu opinión importa!",
      "body": "Ya has registrado al menos 5 partidos. Una reseña sincera en Google Play ayuda a otros jugadores a descubrir Tennis Log y a nosotros a mejorarlo.",
      "later": "Más tarde",
      "action": "Valorar en Google Play",
      "diagTitle": "Invitación a valorar en Play",
      "diag_eligible": "Lista para mostrarse",
      "diag_not_android_app": "Solo en una app Android instalada",
      "diag_under_five": "Disponible tras 5 partidos",
      "diag_cooldown": "Esperando 30 días",
      "diag_opted_out": "No volverá a mostrarse (elección previa)",
      "diag_storage_unavailable": "No se pueden guardar preferencias",
      "diag_signed_out": "Inicia sesión",
      "diag_loading": "Comprobando partidos…"
    }
  },
  "fr": {
    "playReview": {
      "title": "Votre avis compte !",
      "body": "Vous avez enregistré au moins 5 matchs. Un avis sincère sur Google Play aide d’autres joueurs à découvrir Tennis Log et nous aide à l’améliorer.",
      "later": "Plus tard",
      "action": "Donner mon avis sur Google Play",
      "diagTitle": "Invitation à évaluer sur Play",
      "diag_eligible": "Prête à être affichée",
      "diag_not_android_app": "Uniquement dans une application Android installée",
      "diag_under_five": "Disponible après 5 matchs",
      "diag_cooldown": "Délai d’attente de 30 jours",
      "diag_opted_out": "Plus aucune invitation (choix précédent)",
      "diag_storage_unavailable": "Impossible d’enregistrer les préférences",
      "diag_signed_out": "Connexion requise",
      "diag_loading": "Vérification des matchs…"
    }
  },
  "de": {
    "playReview": {
      "title": "Deine Meinung zählt!",
      "body": "Du hast mindestens 5 Matches erfasst. Eine ehrliche Bewertung bei Google Play hilft anderen, Tennis Log zu entdecken, und uns, es zu verbessern.",
      "later": "Später",
      "action": "Bei Google Play bewerten",
      "diagTitle": "Play-Bewertungsanfrage",
      "diag_eligible": "Bereit zur Anzeige",
      "diag_not_android_app": "Nur in einer installierten Android-App",
      "diag_under_five": "Verfügbar ab 5 Matches",
      "diag_cooldown": "30 Tage Wartezeit",
      "diag_opted_out": "Keine weiteren Anfragen (frühere Auswahl)",
      "diag_storage_unavailable": "Einstellungen können nicht gespeichert werden",
      "diag_signed_out": "Anmeldung erforderlich",
      "diag_loading": "Matches werden geprüft…"
    }
  },
  "it": {
    "playReview": {
      "title": "La tua opinione conta!",
      "body": "Hai registrato almeno 5 partite. Una recensione sincera su Google Play aiuta altri giocatori a scoprire Tennis Log e noi a migliorarlo.",
      "later": "Più tardi",
      "action": "Recensisci su Google Play",
      "diagTitle": "Invito alla recensione Play",
      "diag_eligible": "Pronto per essere mostrato",
      "diag_not_android_app": "Solo nell’app Android installata",
      "diag_under_five": "Disponibile dopo 5 partite",
      "diag_cooldown": "Attesa di 30 giorni",
      "diag_opted_out": "Nessun altro invito (scelta precedente)",
      "diag_storage_unavailable": "Impossibile salvare le preferenze",
      "diag_signed_out": "Accesso richiesto",
      "diag_loading": "Controllo delle partite…"
    }
  },
  "ja": {
    "playReview": {
      "title": "あなたの声を聞かせてください！",
      "body": "すでに5試合以上を記録しました。Google Playでの率直なレビューは、ほかのプレーヤーがTennis Logを見つけ、私たちが改善を続ける助けになります。",
      "later": "あとで",
      "action": "Google Playで評価する",
      "diagTitle": "Google Playレビューの案内",
      "diag_eligible": "表示対象です",
      "diag_not_android_app": "インストール済みAndroidアプリでのみ表示",
      "diag_under_five": "5試合以上で表示可能",
      "diag_cooldown": "30日間の待機中",
      "diag_opted_out": "今後は表示しません（以前の選択）",
      "diag_storage_unavailable": "設定を保存できません",
      "diag_signed_out": "ログインが必要です",
      "diag_loading": "試合を確認中…"
    }
  }
} as const;
